import { render, staticRenderFns } from "./shop_renew_download.vue?vue&type=template&id=19b9a98e&scoped=true&"
import script from "./shop_renew_download.vue?vue&type=script&lang=ts&"
export * from "./shop_renew_download.vue?vue&type=script&lang=ts&"
import style0 from "./shop_renew_download.vue?vue&type=style&index=0&id=19b9a98e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b9a98e",
  null
  
)

export default component.exports